// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1enfD","title":"ClientInsurance_title__2Q-hc","itemText":"ClientInsurance_itemText__3GZJt"};